<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Gestion de Stock</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('stock.create')">
        <span>Create</span>
        <span class="hidden md:inline">Stock</span>
      </inertia-link>
    </div>

    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Reference</th>
          <th class="px-6 pt-6 pb-4">BIN</th>
          <th class="px-6 pt-6 pb-4">Model</th>
          <th class="px-6 pt-6 pb-4">Brand</th>
          <th class="px-6 pt-6 pb-4">Cost</th>
          <th class="px-6 pt-6 pb-4">Category</th>
          <th class="px-6 pt-6 pb-4">Type</th>
          <th class="px-6 pt-6 pb-4">Quantity</th>
          <th class="px-6 pt-6 pb-4">Quantity non receptioner</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Creation date</th>
        </tr>
        <tr v-for="stock in stocks.data" :key="stock.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500"
                          :href="route('stock.edit', stock.id)">
              {{ stock.reference }}
              <icon v-if="stock.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('stock.edit', stock.id)"
                          tabindex="-1">
              {{ stock.bin }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('stock.edit', stock.id)"
                          tabindex="-1">
              {{ stock.model.name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('stock.edit', stock.id)"
                          tabindex="-1">
              {{ stock.brand ? stock.brand.name : "" }}

            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('stock.edit', stock.id)"
                          tabindex="-1">
              {{ stock.cost }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('stock.edit', stock.id)"
                          tabindex="-1">
              {{ stock.category.name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('stock.edit', stock.id)"
                          tabindex="-1">
              {{ stock.type }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('stock.edit', stock.id)"
                          tabindex="-1">
              {{ stock.totalQuantity }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('stock.edit', stock.id)"
                          tabindex="-1">
              {{ stock.pendingQuantity }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('stock.edit', stock.id)"
                          tabindex="-1">
              {{ stock.created_at }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('stock.edit', stock.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </inertia-link>
          </td>
        </tr>
        <tr v-if="stocks.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No stock found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="stocks.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'

export default {
  metaInfo: {title: 'Gestion Stock'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
  },
  props: {
    stocks: Object,
    filters: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('stock.list', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
